// voiceEntryActionTypes.ts
// Reducer folder structure in comments
//|--redux
//|   |--voiceEntry
//|   |   |--voiceEntryActions.tsx
//|   |   |--voiceEntryReducer.tsx
//|   |   |--voiceEntrySaga.tsx
//|   |   |--voiceEntryTypes.tsx

export const voiceEntryActionTypes = {
  API_RESPONSE_SUCCESS: 'API_RESPONSE_SUCCESS',
  API_RESPONSE_ERROR: 'API_RESPONSE_ERROR',
  SET_RECORDING_STATUS: 'SET_RECORDING_STATUS',
  SET_REMAINING_TIME: 'SET_REMAINING_TIME',
  RESET_REMAINING_TIME: 'RESET_REMAINING_TIME',
  SET_PROCESSING_STATUS: 'SET_PROCESSING_STATUS',
  SUBMIT_AUDIO_ENTRY: 'SUBMIT_AUDIO_ENTRY',
  CLEAR_ENTRY_RESULTS: 'CLEAR_ENTRY_RESULTS',
  SET_ERROR_MESSAGE: 'SET_ERROR_MESSAGE',
  UPDATE_AUDIO_ENTRY: 'UPDATE_AUDIO_ENTRY',
  APPROVED_ENTRY_SUBMIT: 'APPROVED_ENTRY_SUBMIT'
};

// State structure for voiceEntry reducer
export interface voiceEntryState {
  recordingStatus: boolean;
  remainingTime: number;
  processingStatus: string;
  sqlResult: string;
  entryResult: Record<string, any>; // or define a more specific type if known
  errorMessage: string;
  bookingApproved: boolean;
  missingFields: string[];
  loading: boolean;
  error: string;
}

export interface BalancePaymentDetails {
  bookingId: string;
  totalAmount: number;
  amountAdvanced: number;
  paymentMethod: "UPI" | "Cash" | "---";
  pendingAmount: number;

  // 👇 Add these two lines
  plannedCheckInTime?: string;
  plannedCheckOutTime?: string;
}
